import { createStyles, makeStyles, Theme, useTheme } from '@material-ui/core/styles';
import clsx from 'clsx';
import React, { useState } from 'react';
import { isBrowser } from 'react-device-detect';
import { useGlobal } from 'reactn';
import { IGlobalState } from '../states/GlobalState';
import { drawerWidth } from '../types/constants';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        content: {
            flexGrow: 1,
            // padding: theme.spacing(1),
            marginTop: '60px',
            transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
            }),
            // marginLeft: -drawerWidth,
        },
        contentShift: {
            transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
            }),
            marginLeft: drawerWidth,
        },
        drawerHeader: {
            display: 'flex',
            alignItems: 'center',
            padding: '0 8px',
            ...theme.mixins.toolbar,
            justifyContent: 'flex-end',
        },
        // buttonIcon: {
        //     margin: "1rem",
        //     cursor: "pointer"
        // }
    }),
  );

export type MainProps = {
    children: any;
}
export default function Main(props: MainProps) {
    const classes = useStyles();
    const [drawerIsOpen, setDrawerIsOpen] = useGlobal<IGlobalState, 'drawerIsOpen'>('drawerIsOpen');

    return (
        <div
          className={clsx(classes.content, {
            [classes.contentShift]: drawerIsOpen && isBrowser,
          })}
        >
            {/* <div className={classes.drawerHeader} /> */}
            {props.children}
        </div>
    );
}